import { GLOBAL_ROLES, APP_ROLES } from "shared-frontend";

export const PERMISSION_SETS = {
    ADMIN: [
        GLOBAL_ROLES.ADMIN,
        APP_ROLES.PRESFORM_NET_ADMIN
    ],
    SANDRA: [APP_ROLES.SANDRA]
}